import { APP_NAME, APP_SUBTITLE } from '../data/knowledgeBase';

export const Header = () => {
  return (
    <header className="hero">
      <div className="hero__brand-row">
        <div className="hero__content">
          <h1>{APP_NAME}</h1>
          <p className="hero__subtitle">{APP_SUBTITLE}</p>
          <p className="hero__description">Prepare conversas de valor com mais clareza, consistência e impacto.</p>
          <div className="hero__highlights">
            <span>OPC | Direção estratégica</span>
            <span>SPIN | Diagnóstico consultivo</span>
            <span>EPA | Provocação de valor</span>
            <span>Senoide | Narrativa de venda</span>
          </div>
        </div>
        <img className="hero__logo" src="/cvale-logo.png" alt="Logo C.Vale" />
      </div>
    </header>
  );
};
